import comment from '../../snippets/comment';

export default ({keys, merchant, client}) => `<?php

require 'vendor/autoload.php';
${comment && comment(merchant)}
\\Stripe\\Stripe::setApiKey('${keys.secret}');

header('Content-Type: application/json');

$YOUR_DOMAIN = '${
  client === 'react'
    ? 'http://localhost:3000/checkout'
    : 'http://localhost:4242/public/success.html'
}';

try {
  $checkout_session = \\Stripe\\Checkout\\Session::retrieve($_POST['session_id']);
  $return_url = $YOUR_DOMAIN;

  // Authenticate your user.
  {+portal}
  $session = \\Stripe\\BillingPortal\\Session::create([
    'customer' => $checkout_session->customer,
    'return_url' => $return_url,
  ]);
  {/portal}
  {+portal-redirect}
  header("HTTP/1.1 303 See Other");
  header("Location: " . $session->url);
  {/portal-redirect}
} catch (Error $e) {
  http_response_code(500);
  echo json_encode(['error' => $e->getMessage()]);
}`;
